export default __webpack_public_path__ + "static/delivery-presentation-ebdfcbb40ced42ef7fa5d386145ef62c.png";